<template>
<!--  -->
  <div class='corp-credit-sum'>
      <div style='background: #fff;padding: 20px;'>
        <div class="titleMain">
          <span class="titleSpan">黑名单</span>
          <Icon type="ios-arrow-forward" />
          <span class="titleName">{{personInfo.personName}}</span>
        </div>
        <div class='content'>
            <div class='cover-info'>
              <div class='title'>
                {{personInfo.personName}}
              </div>
              <div class='form'>
                <Row>
                  <Col span="8">
                    <div class='form-item'>
                      <p class='label'>证件类型</p>
                      <p class='value' style='font-weight: 600;'>{{personInfo.idCardType}}</p>
                    </div>
                  </Col>
                  <Col span="8">
                    <div class='form-item'>
                      <p class='label'>证件号码</p>
                      <p class='value no-border-right'>{{personInfo.idCard}}</p>
                    </div>
                  </Col>
                  <Col span="8">
                    <div class='form-item'>
                      <p class='label'>性别</p>
                      <p class='value no-border-right'>{{personInfo.sex}}</p>
                    </div>
                  </Col>
                  <Col span="24">
                    <div class='form-item'>
                      <p class='label no-border-bottom'>注册证书所在单位名称</p>
                      <p class='value no-border-right no-border-bottom'>{{personInfo.corpName}}</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div class='tables' style="margin-top: 20px;">
              <Tabs value="name1">
                  <TabPane label="黑名单总览" name="name1">
                    <Table border :columns="blackColumns" :data="tableData" highlight-row></Table>
                  </TabPane>
              </Tabs>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getPersonBlackListByIdCard, getIdCardInfoByCorpCode } from '@/api/homePage.js';

export default {
  name: '',
  props: {

  },
  data () {
    return {
      personInfo: {

      },
      tableData: [],
      blackColumns: [
          {
              title: '序号',
              type: 'index',
              width: 70,
              align: 'center'
          },
          {
              title: '黑名单类型',
              key: 'blackType',
              minWidth: 220,
              align: 'center'
          },{
              title: '列入部门',
              key: 'cognizanceDepartment',
              width: 150,
              align: 'center'
          },
          {
              title: '列入日期',
              key: 'blacklistStartDate',
              width: 160,
              align: 'center'
          },
          {
              title: '移出日期',
              key: 'blacklistEndDate',
              width: 180,
              align: 'center'
          },
          // {
          //     title: '管理期限',
          //     key: 'awardDepartment',
          //     width: 140,
          //     align: 'center'
          // },
          {
              title: '列入依据',
              key: 'cognizanceBasis',
              minWidth: 220,
              align: 'center'
          }
      ]
    }
  },
  mixins: [],
  components: {

  },
  computed: Object.assign({
      filterCompanyType() {
        return ''
      }
  }, mapGetters([
        '_dict'
    ])
  ),
  watch: {

  },
  created () {
    const idCard18 = this.$route.query.idCard18;
    getPersonBlackListByIdCard(idCard18).then((res) => {
      // console.log(res)
      if (res.status !== 200) return
      if (Array.isArray(res.data)) {
        res.data.map((item) => {
          this._dict.black_type.map((it) => {
            if (item.blackType == it.dicCode) {
              item.blackType = it.dicName
            }
          })
        })
        this.tableData = res.data
      }
    }).catch(() => {
      this.$Message.error('获取详情失败！')
      this.handleBack()
    })
    getIdCardInfoByCorpCode(idCard18).then((res) => {
      if (res.status !== 200) return
      this._dict.idcard_type.map((it) => {
        if (it.dicCode == res.data.idCardType) {
          res.data.idCardType = it.dicName
        }
      })
      this.personInfo = res.data || {}
    })
  },
  mounted () {
    // console.log(this.$store.state)
  },
  methods: {
    handleBack() {
        this.$router.go(-1);
    }
  }
}
</script>

<style lang="less" scoped>
.corp-credit-sum {
  background: #f5f5f5;
  padding: 30px 8%;
}
.titleMain {
    height: 40px;
    line-height: 40px;
    .titleSpan {
        font-size: 12px;
        color: gray;
    }
    .titleName {
        font-size: 12px;
    }
}
.content{
  .cover-info {
    border: 1px solid #E9E9E9;
    padding: 20px;
    .title{
      font-size: 18px;
      &>span{
        font-size: 16px;
        font-weight: 600;
      }
    }
    .form {
      margin: 12px 0px;
      border: 1px solid #E9E9E9;
      .form-item {
        display: flex;
        flex-direction: row;
        height: 50px;
        .label{
          width: 160px;
          padding: 12px 16px;
          // background: #F9F9F9;
          font-weight: 600;
          font-size: 12px;
          text-align: right;
          line-height: 26px;
          border-right: 1px solid #E9E9E9;
          border-bottom: 1px solid #E9E9E9;
        }
        .value{
          flex: 1;
          padding: 12px 16px;
          font-size: 12px;
          line-height: 26px;
          border-right: 1px solid #E9E9E9;
          border-bottom: 1px solid #E9E9E9;
          background: #fff;
        }
        .value.no-border-right {
          border-right: none;
        }
        .label.no-border-bottom, .value.no-border-bottom {
          border-bottom: none;
        }
      }
    }
  }

}
</style>
<style lang="less">
  .tables {
    /deep/.ivu-tabs-nav-scroll {
      background: #fff;
    }
  }
</style>
